import { APIConfig, AuthConfig } from '@aws-amplify/core';

export const environment = {
  name: 'prod',
  production: true,
  clientApp: true,
  frontendType: 'chat-widget',
  aws_config: {
    Auth: {
      Cognito: {
        identityPoolId: 'eu-central-1:bcfe979d-0446-4c4e-9ccc-1d98084842ce',
        allowGuestAccess: true,
        userPoolClientId: '4d7ak51bm2f9g5g7eodliuusnd',
        userPoolId: 'eu-central-1_eoqOvzW17',
      },
    } satisfies AuthConfig,
    API: {
      GraphQL: {
        endpoint: 'https://sbenphpftbbfhkuzed6elmq5d4.appsync-api.eu-central-1.amazonaws.com/graphql',
        region: 'eu-central-1',
        defaultAuthMode: 'iam',
      },
    } satisfies APIConfig,
  },
  bucket: {
    aws_user_files_s3_bucket: 'sanacorp-assets-store-prod',
    aws_user_files_s3_bucket_base_url: 'https://sanacorp-assets-store-prod.s3.eu-central-1.amazonaws.com',
  },
  msgCache: {
    enabled: true,
    lifetime: 3600000, // 1 hour
  },
  pushNotificationPublicKey: 'BFPQN5rG6rLE40lNAjriQtt_QeTGAdYyzn0XciBScxPTWiNRdRgt1VPSzJvZ7jjyCdXAZqK7lJZ1s_tpVPnHxMI',
  sentryDSN: 'https://3143482e6baf48d984c0ade6818dbbf6@sentry.sanacorp.cloud/11',
  animated: true,
  checkForHolidays: true,
  baseUrl: 'https://widget.meineapotheke.de/',
  endUserBaseUrl: 'https://www.meineapotheke.de/meadirekt-chat',
  imports: [],
};
